import React from "react";

const RenewPayBar  = () => {
    return(
        <div className="conf-bar">
            <ul className="conf-bar__row">
                {/*<li className="text-jost-sb-22 completed">CLUB Details</li>*/}
                {/*<li className="text-jost-sb-22 active ">Golf Courses</li>*/}
                <li className="text-jost-sb-22 ">Payment DETAILS</li>

            </ul>
        </div>
    );
};
export default RenewPayBar;